import { useAuth } from "~/hooks/useAuth";
import { useItemCount } from "~/state/items";
import {
  allowsCustomSpecs,
  allowsReceipts,
  allowsReminders,
  itemAllowance,
  photoAllowance,
  PLAN_LIMITS,
} from "~/utils/plan-limits";
import { planTierFor } from "~/utils/onboarding";

/**
 * Counts come from the local Legend-State store rather than the server so the
 * limit UI stays accurate while offline. The database re-checks on write.
 */
export function usePlan() {
  const { user } = useAuth();
  const tier = planTierFor(user);
  const itemCount = useItemCount();

  return {
    tier,
    isPro: tier === "pro",
    limits: PLAN_LIMITS[tier],
    items: itemAllowance(tier, itemCount),
    canUseReceipts: allowsReceipts(tier),
    canUseCustomSpecs: allowsCustomSpecs(tier),
    canUseReminders: allowsReminders(tier),
    photosFor: (used: number) => photoAllowance(tier, used),
  };
}
